import { useEffect, useRef } from 'react';
import {
  PiBasketLight,
  PiCubeLight,
  PiDeviceMobileSpeakerThin,
  PiDevicesLight,
  PiRocketLaunchLight,
  PiStrategyLight,
  PiTestTubeLight,
  PiThreadsLogoLight,
} from 'react-icons/pi';
import gsap from 'gsap/dist/gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import heaxagon from '../../../assets/image/hexagonMultiple.png';

gsap.registerPlugin(ScrollTrigger);

export const Strategy: React.FC = () => {
  const { t } = useTranslation('pageExpertise');
  const el = useRef(null);

  useEffect(() => {
    const data = {
      y: 0,
      opacity: 1,
      duration: 4,
      scrollTrigger: {
        trigger: '#strategy-subtile',
        start: 'top 100%',
        end: 'top 30%',
        scrub: true,
      },
    };
    gsap.to('#strategy-content', {
      ...data,
      scrollTrigger: { ...data.scrollTrigger, trigger: '#strategy-content' },
    });
    gsap.to('#strategy', {
      ...data,
      scrollTrigger: {
        ...data.scrollTrigger,
        start: 'top 100%',
        end: 'top 20%',
        trigger: '#strategy',
      },
    });
  }, []);

  return (
    <section
      ref={el}
      id="strategy"
      className="bg-gradient relative flex min-h-[80vh] w-full items-center overflow-hidden pt-20 md:pt-28 lg:pt-36">
      <Image
        className="absolute -left-20 bottom-0 h-full w-auto skew-y-6 object-contain opacity-5"
        src={heaxagon}
        alt="hexagon"
        blurDataURL={heaxagon}
        width={960}
        height={540}
      />

      <div className="container z-50">
        <div
          id="strategy-content"
          className="grid translate-y-[300px] text-white opacity-0 lg:grid-cols-2">
          <h2
            className="text-heading-about mb-8 font-black md:mb-4"
            dangerouslySetInnerHTML={{ __html: t('strategy.title') }}
          />

          <div className="hidden lg:flex" />
          <div className="hidden lg:flex" />

          <div className="strategy-text text-white">
            <p className="mb-2" dangerouslySetInnerHTML={{ __html: t('strategy.description') }} />
          </div>
        </div>

        <div className="mt-24 grid gap-1 md:grid-cols-2">
          <div className="col-span-1 flex items-center gap-x-4 border border-white/10 bg-[#140f1d] p-4 py-6 lg:p-6 lg:py-8">
            <PiCubeLight size={26} />
            {t('strategy.techStrategyAndAdvisory')}
          </div>
          <div className="col-span-1 flex items-center gap-x-4 border border-white/10 bg-[#140f1d] p-6 py-8">
            <PiDevicesLight size={26} />
            {t('strategy.innovativeTechnology')}
          </div>
          <div className="col-span-1 flex items-center gap-x-4 border border-white/10 bg-[#140f1d] p-4 py-6 lg:p-6 lg:py-8">
            <PiRocketLaunchLight size={26} />
            {t('strategy.digitalProductDevelopment')}
          </div>
          <div className="col-span-1 flex items-center gap-x-4 border border-white/10 bg-[#140f1d] p-4 py-6 lg:p-6 lg:py-8">
            <PiDeviceMobileSpeakerThin size={26} />
            {t('strategy.mobileApplications')}
          </div>
          <div className="col-span-1 flex items-center gap-x-4 border border-white/10 bg-[#140f1d] p-4 py-6 lg:p-6 lg:py-8">
            <PiBasketLight size={26} />
            {t('strategy.eCommerceSolutions')}
          </div>
          <div className="col-span-1 flex items-center gap-x-4 border border-white/10 bg-[#140f1d] p-4 py-6 lg:p-6 lg:py-8">
            <PiStrategyLight size={26} />
            {t('strategy.uxUi')}
          </div>
          <div className="col-span-1 flex items-center gap-x-4 border border-white/10 bg-[#140f1d] p-6 py-8">
            <PiTestTubeLight size={26} />
            {t('strategy.qualityAssurance')}
          </div>
          <div className="col-span-1 flex items-center gap-x-4 border border-white/10 bg-[#140f1d] p-6 py-8">
            <PiThreadsLogoLight size={26} />
            {t('strategy.digitalStrategy')}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Strategy;
